/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
    AfterViewInit,
    Component,
    ComponentRef,
    Inject,
    OnDestroy,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalConfiguration } from '@app/shared/models/modal.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false,
})
export class ModalComponent implements AfterViewInit, OnDestroy {
    @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
    private subscription: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) public configuration: ModalConfiguration,
        public dialogRef: MatDialogRef<ModalComponent>
    ) {}

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.container.clear();

            /* eslint-disable @typescript-eslint/no-explicit-any */
            const componentRef: ComponentRef<any> = this.container.createComponent(
                this.configuration.component
            );
            /* eslint-enable @typescript-eslint/no-explicit-any */

            if (this.configuration.inputs) {
                for (const [key, value] of this.configuration.inputs) {
                    componentRef.instance[key] = value;
                }
            }

            this.subscription = componentRef.instance['closeModal'].subscribe((arg: boolean) =>
                this.dialogRef.close(arg)
            );
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
